if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const qtyInput = document.querySelector(".product-form__quantity quantity-input input");
        // const personalizeblock = document.querySelector(".personalize_product_block");
        var personalize_price;
        var mainProductPrice;
        var mainProductComPrice;
        var dataPersonalizeId;
        
        const comparePrice = document.querySelector(".product__info-wrapper .compare_price").getAttribute("data-compare-price");
        const uniqueId = Date.now(); 
        const formData = new FormData(this.form);
   
        var checkIsCustom = localStorage.getItem("customSize");
        // console.log("checkIsCustom",checkIsCustom);
        let isDrawer;
       
        console.log("checkIsCustom",isDrawer);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        
          formData.append('properties[_compare_price]',comparePrice);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response,false);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              
              if (checkIsCustom) {
                // If custom size is selected, show drawer
                isDrawer = true;
              } else {
                const crossSell = window.crossSellData?.[response.id];
              
                if (crossSell) {
                  // If cross-sell exists, hide drawer
                  isDrawer = false;
                } else {
                  // If no cross-sell, show drawer
                  isDrawer = true;
                }
              }
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response,isDrawer);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            // console.log("window.crossSellData",window.crossSellData);
            let isAddOnProduct = document.querySelector("[name='addOnProduct']")?.checked;
            let checkPersonalization = document.querySelector(".personalize_product_block .personalization_result")?.getAttribute("personlization");
            
            if(!checkIsCustom){
              fetch('/cart.js')
              .then(res => res.json())
              .then(cart => {
                const currentvariantId = parseInt(formData.get('id'), 10);
                const existingItem = cart.items.find(item => item.variant_id === currentvariantId);
                // Cart crossell data
                const targetItem = existingItem || cart.items[0];
                if(!targetItem) return;
                if(document.body.classList.contains('template-product')){
                  renderFirstItem(targetItem,qtyInput.value,isAddOnProduct,checkPersonalization);
                
                  const variantId = targetItem.variant_id;
                  const crossSell = window.crossSellData[variantId];


                  
                  if(crossSell){
                      renderCrossSellProduct(crossSell);
                    const cartPopup = document.querySelector(".cartitem-popup");
                    if(cartPopup){
                      document.querySelector(".popup-overlay")?.classList.add('active');
                      cartPopup.classList.add('active');
                      document.body.classList.add('overflow-hidden');
                        document.querySelector('.cartitem-popup .popup-wrap .popup-closebutton').addEventListener('click', function () {
 dataLayer.push({
        'event': "gtm_event_add_to_cart_atPDP_close_crosssell_popup",
        'ecommerce': {
            'currency': "INR",
            'value':  parseFloat(targetItem.original_price.toFixed(2)),            
            'items': [
                {
                    'item_id': targetItem.sku,
                    'item_name': targetItem.product_title,
                    'discount': parseFloat((targetItem.original_price - targetItem.discounted_price).toFixed(2)), //pr_price - deal_price
                    'index': 0,
                    'item_brand': "SleepyCat",
                    'item_category': targetItem.product_type,
                    'price': parseFloat(targetItem.original_price.toFixed(2)),
                    'product-variationId': targetItem.variant_id,
                    'variant': targetItem.variant_title,
                    'quantity': targetItem.quantity,
                    'deal-price': parseFloat(targetItem.discounted_price.toFixed(2)),
                    'product-category': targetItem.product_type,
                    'product-size': targetItem.options_with_values.find(item => item.name === "DIMENSION")?.value,
                    'product-color': targetItem.options_with_values.find(item => item.name === "COLOR")?.value,
                    'product-pack': "",
                    'page-path': targetItem.url
                }
            ]
            }
        });
                      })
                    }
                  }
                }
              });
            }
         
            //custom addToCart with mainProduct
                let itemArr = [];
                let timestamp = Date.now(); 
                let personalizationElem = document.querySelector(".personalize_product_block");
            
                // Object to store items
                let item_obj = {};
            
                // // Check for Personalization
                // if (personalizationElem) {
                //   let personlization_text = document.querySelector("#textInput").value;
                //   let checkPersonliazation = personalizationElem.querySelector(".personalization_result");
                //   let isPersonlization = checkPersonliazation.getAttribute("personlization");
          
                //   if (isPersonlization) {
                //     let pro_var_id = personalizationElem.querySelector(".product_wrapper").getAttribute("data-personalize-id");
                //     item_obj[pro_var_id] = {
                //       id: pro_var_id,
                //       quantity: qtyInput.value,
                //       properties: {
                //         "_isPersonalized": true,
                //         "_bundle_unique_id": window.productTimestamp,
                //         "personlization_text": personlization_text
                //       }
                //     };
                //   }
                // }
            
                // Check for Add-On Product
                
                if (isAddOnProduct) {
                  let addOnproductid = document.querySelector(".addOnProducts-wrapper .product_wrapper").getAttribute("data-addon-id");
                  if (addOnproductid) {
                    item_obj[addOnproductid] = {
                      id: addOnproductid,
                      quantity: qtyInput.value
                    };
                  }
                }
            
                // Convert object values to an array
                itemArr = Object.values(item_obj);
            
                if (itemArr.length > 0) {
                    const form_data = { items: itemArr };
                    custom_addtocart_fun(form_data, true); // Call only once
                }
             //custom addToCart with mainProduct
            
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            if(document.body.classList.contains('template-product')){
            document.querySelector(".product-sticky-bar-wrap .loading__spinner").classList.add('hidden');
            }

            if(document.body.classList.contains('template-quiz-page')){
              window.location = window.routes.cart_url;
            }

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
